import React from 'react';
import PropTypes from 'prop-types';
import Location from '../../core/Location';
import { connect } from 'react-redux';

import NotificationPopupCustomContent from './NotificationPopUpCustomContent';
import NotificationPopupTextContent from './NotificationPopUpTextContent';
import { hidePopup } from '../../actions/NotificationPopupActions';

const POPUP_TIMEOUT = 50000;

class NotificationPopupsManager extends React.Component {
  componentWillUnmount() {
    this.closePopup();
  }
  closePopup = () => {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
    }
    this.popupShown = false;
    const type = this.props.notificationPopupData.get('type');
    this.props.hidePopup();
  };
  render() {
    const notificationPopupData = this.props.notificationPopupData;
    if (!notificationPopupData.get('type') || this.popupShown) {
      return null;
    }
    this.popupShown = true;
    if (!notificationPopupData.get('noTimeout')) {
      this.timeoutHandler = setTimeout(this.closePopup, POPUP_TIMEOUT);
    }
    if (notificationPopupData.get('type') === 'SHOW_CUSTOM_POPUP') {
      return (
        <NotificationPopupCustomContent
          data={notificationPopupData}
          closePopup={this.closePopup}
          lang={this.props.lang}
        />
      );
    }
    return (
      <NotificationPopupTextContent
        data={notificationPopupData}
        closePopup={this.closePopup}
      />
    );
  }
}

NotificationPopupsManager.propTypes = {
  notificationPopupData: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  hidePopup: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
};

const mapState = state => ({
  notificationPopupData: state.notificationPopupData,
});

const mapDispatch = dispatch => {
  return {
    hidePopup: () => dispatch(hidePopup()),
  };
};

export default connect(mapState, mapDispatch)(NotificationPopupsManager);



// WEBPACK FOOTER //
// ./src/components/Popup/NotificationPopUpManager.js